import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accentMark'
})
export class AccentMarkPipe implements PipeTransform {

  transform(value: any, show: boolean = false): any {
    if (typeof value !== 'undefined' || value !== null || value !== '' || value !== undefined) {
      if (show === false) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      } else {
        return value;
      }
    } else {
      return value;
    }
  }

}
